module.exports = __webpack_public_path__ + "static/media/viv-dev.de1849c0.jpg";